(function () {
  function setup(frame) {
    frame.classList.add('yuma-launcher-hidden');

    new MutationObserver(function () {
      frame.classList.toggle('yuma-launcher-hidden', parseInt(frame.style.width) <= 72);
    }).observe(frame, { attributes: true, attributeFilter: ['style'] });
  }

  var frame = document.getElementById('yuma-widget');
  if (frame) {
    setup(frame);
    return;
  }

  // #yuma-widget n'est pas encore dans le DOM (Yuma charge async) — on attend
  new MutationObserver(function (mutations, obs) {
    var f = document.getElementById('yuma-widget');
    if (f) {
      obs.disconnect();
      setup(f);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
